import React, { useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import AuthServices from "../services/AuthServices";
import { AdminContext } from "../providers/AdminContext";

const ProtectedRoutes = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AdminContext);

  useEffect(() => {
    checkUserData();
  }, []);

  useEffect(() => {
    checkUserData();
  }, [user]);

  const isValid = () => {
    return !(
      user.user.rol === "eira-professional" &&
      (user.first_name === "" ||
        user.last_name === "" ||
        user.birth === "" ||
        user.nationality === null ||
        user.nationality === "")
    );
  };

  const checkUserData = () => {
    if (!isValid()) {
      navigate("/admin/profile");
    }
    setLoading(false);
  };

  if (!isValid()) {
    return <></>;
  }

  if (loading) {
    return (
      <div className="w-screen h-screen flex flex-row justify-center items-center">
        <Spin indicator={<LoadingOutlined style={{ color: "#666666" }} />} />
      </div>
    );
  }

  return <Outlet />;
};

export default ProtectedRoutes;
